import * as React from 'react';
import cx from 'clsx';

import JackpotBox from '../JackpotBox/JackpotBox';

import { selectJackpots, decideJackpotBoxScale } from './utils';

import styles from './JackpotsContainer.module.scss';
import { JackpotStaticTexts } from '../../types';

import {
  WrapperSize,
  WrapperJackpotTiers,
  OverlayJackpot,
  WrapperType,
} from '../../types';

interface JackpotsContainerPropsInterface {
  wrapperSize: WrapperSize;
  currencyCode: string;
  locale: string;
  tiers: WrapperJackpotTiers;
  valueAnimationDuration: number;
  overlayTier?: OverlayJackpot;
  scaleLogo: boolean;
  wrapperType: WrapperType;
  staticTexts: JackpotStaticTexts;
}

const JackpotsContainer = ({
  wrapperSize,
  currencyCode,
  locale,
  tiers,
  valueAnimationDuration,
  overlayTier,
  scaleLogo,
  wrapperType,
  staticTexts,
}: JackpotsContainerPropsInterface) => {
  const selectedJackpots = selectJackpots(tiers, wrapperSize);
  return (
    <div>
      <div className={styles.container} data-testid="jackpots-holder">
        {selectedJackpots.map((tier, index) => (
          <JackpotBox
            key={tier.name}
            {...tier}
            scale={decideJackpotBoxScale(index, wrapperSize)}
            currencyCode={currencyCode}
            locale={locale}
            valueAnimationDuration={valueAnimationDuration}
            wrapperType={wrapperType}
            timeStaticTexts={staticTexts.time}
          />
        ))}
      </div>
      {overlayTier && (
        <div
          className={cx(styles.overlay, scaleLogo && styles.scaleLogo)}
          style={{
            backgroundColor: 'rgb(11,11,79)',
            backgroundImage: overlayTier.background
              ? `url(${overlayTier.background?.source?.modern?.normal ||
                  overlayTier.background?.source.normal})`
              : '',
          }}
          data-testid="jackpot-overlay"
        >
          <JackpotBox
            state={'won'}
            curValue={overlayTier.value}
            winValue={overlayTier.nextValue}
            winMessage={overlayTier.message}
            nextJackpotName={overlayTier.nextJackpotName}
            name={overlayTier.name}
            isOverlay={true}
            scale={decideJackpotBoxScale(1, wrapperSize)}
            currencyCode={currencyCode}
            locale={locale}
            valueAnimationDuration={valueAnimationDuration}
            wrapperType={wrapperType}
            timeStaticTexts={staticTexts.time}
          />
        </div>
      )}
    </div>
  );
};

export default JackpotsContainer;
